"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Swedish
var strings = {
  prefixAgo: 'för',
  prefixFromNow: 'om',
  suffixAgo: 'sedan',
  suffixFromNow: '',
  seconds: 'mindre än en minut',
  minute: 'ungefär en minut',
  minutes: '%d minuter',
  hour: 'ungefär en timme',
  hours: 'ungefär %d timmar',
  day: 'en dag',
  days: '%d dagar',
  month: 'ungefär en månad',
  months: '%d månader',
  year: 'ungefär ett år',
  years: '%d år'
};
var _default = strings;
exports["default"] = _default;